export const LogoMark = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M32 3C32 3 11 25.5 11 40.5a21 21 0 0 0 42 0C53 25.5 32 3 32 3Z"
      fill="#0F2C59"
    />
    <path
      d="M32 3C32 3 11 25.5 11 40.5a21 21 0 0 0 42 0C53 25.5 32 3 32 3Z"
      fill="url(#ams-sheen)"
      fillOpacity="0.35"
    />
    <path
      d="M32 51.5c-3.4-3-9-6.4-9-10.8 0-2.8 2.1-5 4.8-5 1.7 0 3.2.9 4.2 2.2 1-1.3 2.5-2.2 4.2-2.2 2.7 0 4.8 2.2 4.8 5 0 4.4-5.6 7.8-9 10.8Z"
      fill="#FF6B6B"
    />
    <path
      d="M32 12v14M25 19h14"
      stroke="#7DD3FC"
      strokeWidth="3.2"
      strokeLinecap="round"
      opacity="0.9"
    />
    <defs>
      <linearGradient id="ams-sheen" x1="20" y1="6" x2="46" y2="58" gradientUnits="userSpaceOnUse">
        <stop stopColor="#38BDF8" />
        <stop offset="1" stopColor="#0F2C59" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

const Logo = ({ dark = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="logo">
    <LogoMark size={38} />
    <span className="flex flex-col leading-none">
      <span className={`font-heading text-[15px] sm:text-base font-extrabold tracking-tight ${dark ? "text-white" : "text-[#0F2C59]"}`}>
        Aide au Monde <span className="text-[#FF6B6B]">&amp;</span> Santé
      </span>
      <span className={`text-[10px] font-semibold uppercase tracking-[0.22em] ${dark ? "text-sky-300" : "text-[#0284C7]"}`}>
        Maladie de Waldmann
      </span>
    </span>
  </span>
);

export default Logo;
